module.exports = __webpack_public_path__ + "img/americansamoa.d4c05745.svg";